module.exports = __webpack_public_path__ + "static/media/reshot-icon-arrow-left.ab19fec6.svg";